module.exports = __webpack_public_path__ + "img/m.dfa31a9c.jpg";